import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { DOMAIN } from "../../../configs/api";
import {
  getRequest,
  postRequest,
  deleteRequest,
} from "../../../helpers/request";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
// import MessageRoundedIcon from '@mui/icons-material/MessageRounded';
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { useRef as useReactRef } from "react";

export default function KeymessageAnnotation() {
  const { presentationId, kmId } = useParams();
  const src = `${DOMAIN}/view/presentations/${presentationId}/key-messages/${kmId}/dsp`;

  const overlayRef = useRef(null);
  const [annotations, setAnnotations] = useState([]);
  const [selected, setSelected] = useState(null); // {x, y}
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [addCard, setAddCard] = useState(false);
  const [text, setText] = useState("");
  const [dimensions, setDimensions] = useState({ width: 1024, height: 768 });
  const [replyOpen, setReplyOpen] = useState({});
  const [replyText, setReplyText] = useState({});
  const [activeAnnotation, setActiveAnnotation] = useState(null);
  const [tempAnnotation, setTempAnnotation] = useState(null); // For temporary annotation marker
  const [targgetedDevice, setTargetedDevice] = useState("Default");

  const [commentMenuAnchor, setCommentMenuAnchor] = useState(null);
  const [commentMenuCommentId, setCommentMenuCommentId] = useState(null);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingCommentText, setEditingCommentText] = useState("");

  const userStore = useSelector((state) => state.userStore);
  const { config } = userStore;
  const devices = config?.["DEVICES"] || [];

  console.log(devices);

  // this is to get the device info from presentation
  useEffect(() => {
    getRequest(`presentations/${presentationId}`, {
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "x-refresh-token": localStorage.getItem("refresfhToken"),
        changeOrigin: true,
      },
    }).then((response) => {
      const targettedDevice = response.data.presentation.targettedDevice;
      if (targettedDevice && devices.length > 0) {
        // Try to match by name or id (adjust as needed)
        const matchedDevice = devices.find(
          (d) => d.name === targettedDevice || d.id === targettedDevice
        );
        if (matchedDevice && matchedDevice.width && matchedDevice.height) {
          setDimensions({
            width: matchedDevice.width,
            height: matchedDevice.height,
          });
        }
      }
    });
  }, [presentationId, devices.length]);

  // Get annotations
  useEffect(() => {
    getRequest(
      `presentations/${presentationId}/key-messages/${kmId}/annotations`
    )
      .then((data) => {
        setAnnotations(data.data);
      })
      .catch((err) => {
        setAnnotations([]);
      });
  }, [presentationId, kmId]);

  // Click to add annotation
  const handleOverlayClick = (e) => {
    const rect = overlayRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setTempAnnotation({ x, y });
    setText("");
    setAddCard(true);
  };

  // Save new annotation
  const handleSaveAnnotation = async () => {
    if (!tempAnnotation) return;
    postRequest(
      `presentations/${presentationId}/key-messages/${kmId}/annotations`,
      {
        x: tempAnnotation.x,
        y: tempAnnotation.y,
        text,
      }
    ).then((newAnnotation) => {
      setAnnotations([...annotations, newAnnotation.data]);
      setAddCard(false);
      setTempAnnotation(null);
      setText("");
    });
  };

  // Cancel annotation
  const handleCancelAnnotation = () => {
    setAddCard(false);
    setTempAnnotation(null);
    setText("");
  };

  // ReplyBox component for annotation replies

  // Function to delete a comment
  const handleDeleteComment = async (annotationId, commentId) => {
    try {
      await axios.delete(
        `${DOMAIN}/api/presentations/${presentationId}/key-messages/${kmId}/annotations/${annotationId}/comments/${commentId}`,
        {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refresfhToken"),
          },
        }
      );
      setAnnotations((prev) =>
        prev.map((ann) =>
          ann._id === annotationId
            ? {
                ...ann,
                comments: ann.comments.filter((com) => com._id !== commentId),
              }
            : ann
        )
      );
    } catch (err) {
      console.error("Failed to delete comment", err);
    }
    setCommentMenuAnchor(null);
    setCommentMenuCommentId(null);
  };

  // Function to delete an annotation
  const handleDeleteAnnotation = async (annotationId) => {
    try {
      await axios.delete(
        `${DOMAIN}/api/presentations/${presentationId}/key-messages/${kmId}/annotations/${annotationId}`,
        {
          headers: {
            "x-access-token": localStorage.getItem("token"),
            "x-refresh-token": localStorage.getItem("refresfhToken"),
          },
        }
      );
      setAnnotations((prev) => prev.filter((ann) => ann._id !== annotationId));
    } catch (err) {
      console.error("Failed to delete annotation", err);
    }
    setCommentMenuAnchor(null);
    setCommentMenuCommentId(null);
  };

  // Refs for annotation cards
  const annotationRefs = useReactRef({});

  return (
    <Box display="flex" height="100vh" sx={{ justifyContent: "space-between", gap: 2, width: "100%" }}>
      <Box
        position="relative"
        width={dimensions.width}
        height={dimensions.height}
      >
        <iframe
          src={src}
          title="Key Message Preview"
          style={{
            width: dimensions.width,
            height: dimensions.height,
            border: "none",
          }}
        />
        <Box
          ref={overlayRef}
          onClick={handleOverlayClick}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: dimensions.width,
            height: dimensions.height,
            cursor: "crosshair",
            zIndex: 2,
          }}
        >
          {annotations.map((a, i) => (
            <Box
              key={a._id || i}
              title={(a.comments?.[0]?.text || "").slice(0, 20)}
              onClick={(e) => {
                e.stopPropagation();
                setActiveAnnotation(a);
                // Scroll to annotation card
                setTimeout(() => {
                  if (annotationRefs.current[a._id]) {
                    annotationRefs.current[a._id].scrollIntoView({ behavior: "smooth", block: "center" });
                  }
                }, 0);
              }}
              sx={{
                position: "absolute",
                left: a.x - 12,
                top: a.y - 12,
                width: 24,
                height: 24,
                zIndex: 3,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
                border:
                  activeAnnotation && activeAnnotation._id === a._id
                    ? "2px solid #1976d2"
                    : "2px solid #fff",
                boxShadow:
                  activeAnnotation && activeAnnotation._id === a._id
                    ? "0 0 8px #1976d2"
                    : 2,
              }}
            >
              <ChatBubbleIcon
                sx={{
                  color:
                    activeAnnotation && activeAnnotation._id === a._id
                      ? "#1976d2"
                      : "error.main",
                  fontSize: 24,
                  filter: "drop-shadow(0 1px 2px #fff)",
                }}
              />
            </Box>
          ))}
          {/* Temporary marker for new annotation */}
          {addCard && tempAnnotation && (
            <Box
              key="temp-annotation"
              sx={{
                position: "absolute",
                left: tempAnnotation.x - 12,
                top: tempAnnotation.y - 12,
                width: 24,
                height: 24,
                zIndex: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "transparent",
                border: "2px dashed #1976d2",
                // boxShadow: "0 0 8px #1976d2",
              }}
            >
              <ChatBubbleIcon sx={{ color: "#1976d2", fontSize: 24 }} />
            </Box>
          )}
        </Box>
      </Box>

      {/* Annotation list view (fallback) */}
      {!sidebarOpen && (
        <Paper
          elevation={1}
          sx={{
            width: 320,
            height: "100vh",
            bgcolor: "#fafafa",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h4" m={2}>
            Comments {annotations.length}
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Box component="ul" sx={{ pl: 2, m: 0, flex: 1, overflowY: "auto" }}>
            {annotations.map((a) => {
              return (
                <Card
                  ref={el => {
                    if (el) annotationRefs.current[a._id] = el;
                  }}
                  sx={{
                    mb: 1,
                    cursor: "pointer",
                    border:
                      activeAnnotation && activeAnnotation._id === a._id
                        ? "2px solid #1976d2"
                        : "none",
                    boxShadow:
                      activeAnnotation && activeAnnotation._id === a._id
                        ? 6
                        : 1,
                  }}
                  key={a._id}
                  onClick={() => setActiveAnnotation(a)}
                >
                  <CardContent>
                    <Typography variant="body2">
                      {a.comments.map((c, idx) => (
                        <Box key={c._id} mb={2}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box display="flex" flexDirection="column">
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  fontWeight: "bold",
                                  color: "text.secondary",
                                }}
                              >
                                {c.createdBy?.name ||
                                  localStorage.getItem("name") ||
                                  "Unknown User"}
                              </Typography>
                              <Typography sx={{ fontSize: 10 }}>
                                {c.createdAt
                                  ? new Date(c.createdAt).toLocaleString()
                                  : "Just now"}
                              </Typography>
                            </Box>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setCommentMenuAnchor(e.currentTarget);
                                setCommentMenuCommentId(c._id);
                              }}
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                            <Menu
                              anchorEl={commentMenuAnchor}
                              open={
                                Boolean(commentMenuAnchor) &&
                                commentMenuCommentId === c._id
                              }
                              onClose={() => {
                                setCommentMenuAnchor(null);
                                setCommentMenuCommentId(null);
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  setEditingCommentId(c._id);
                                  setEditingCommentText(c.text);
                                  setCommentMenuAnchor(null);
                                  setCommentMenuCommentId(null);
                                }}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  if (idx === 0) {
                                    handleDeleteAnnotation(a._id);
                                  } else {
                                    handleDeleteComment(a._id, c._id);
                                  }
                                }}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </Box>

                          {editingCommentId === c._id ? (
                            <Box
                              display="flex"
                              gap={1}
                              alignItems="center"
                              mt={1}
                            >
                              <TextField
                                value={editingCommentText}
                                onChange={(e) =>
                                  setEditingCommentText(e.target.value)
                                }
                                size="small"
                                fullWidth
                                autoFocus
                              />
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={async () => {
                                  try {
                                    await axios.put(
                                      `${DOMAIN}/api/presentations/${presentationId}/key-messages/${kmId}/annotations/${a._id}/comments/${c._id}`,
                                      { text: editingCommentText },
                                      {
                                        headers: {
                                          "x-access-token":
                                            localStorage.getItem("token"),
                                          "x-refresh-token":
                                            localStorage.getItem(
                                              "refresfhToken"
                                            ),
                                        },
                                      }
                                    );
                                    setAnnotations((prev) =>
                                      prev.map((ann) =>
                                        ann._id === a._id
                                          ? {
                                              ...ann,
                                              comments: ann.comments.map(
                                                (com) =>
                                                  com._id === c._id
                                                    ? {
                                                        ...com,
                                                        text: editingCommentText,
                                                      }
                                                    : com
                                              ),
                                            }
                                          : ann
                                      )
                                    );
                                    setEditingCommentId(null);
                                    setEditingCommentText("");
                                  } catch (err) {
                                    console.error(
                                      "Failed to edit comment",
                                      err
                                    );
                                  }
                                }}
                                disabled={!editingCommentText.trim()}
                              >
                                Save
                              </Button>
                              <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                onClick={() => {
                                  setEditingCommentId(null);
                                  setEditingCommentText("");
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                          ) : (
                            <Typography variant="body2">{c.text}</Typography>
                          )}
                        </Box>
                      ))}
                    </Typography>
                    {/* Always show Reply button, open ReplyBox only for this annotation */}
                    {!replyOpen[a._id] && (
                      <Button
                        sx={{ mt: 1 }}
                        variant="outlined"
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          setReplyOpen((prev) => ({ ...prev, [a._id]: true }));
                        }}
                      >
                        Reply
                      </Button>
                    )}
                    {replyOpen[a._id] && (
                      <ReplyBox
                        value={replyText[a._id] || ""}
                        onChange={(e) =>
                          setReplyText((prev) => ({
                            ...prev,
                            [a._id]: e.target.value,
                          }))
                        }
                        onReply={() => {
                          if ((replyText[a._id] || "").trim()) {
                            postRequest(
                              `presentations/${presentationId}/key-messages/${kmId}/annotations/${a._id}/comments`,
                              { text: replyText[a._id] }
                            ).then((newComment) => {
                              setAnnotations((prev) =>
                                prev.map((ann) =>
                                  ann._id === a._id
                                    ? {
                                        ...ann,
                                        comments: [
                                          ...ann.comments,
                                          newComment.data,
                                        ],
                                      }
                                    : ann
                                )
                              );
                              setReplyText((prev) => ({
                                ...prev,
                                [a._id]: "",
                              }));
                              setReplyOpen((prev) => ({
                                ...prev,
                                [a._id]: false,
                              }));
                            });
                          }
                        }}
                      />
                    )}
                  </CardContent>
                  {/* <CardActions>
                    <Button size="small">Learn More</Button>
                  </CardActions> */}
                </Card>
              );
            })}
            {addCard && tempAnnotation && (
              <Card sx={{ mb: 1 }}>
                <Paper
                  elevation={3}
                  sx={{
                    width: 320,
                    p: 3,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h6" mb={2}>
                    Add Annotation
                  </Typography>
                  <TextField
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    label="Enter your comment"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <Box display="flex" gap={2}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleCancelAnnotation}
                      fullWidth
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSaveAnnotation}
                      fullWidth
                      disabled={!text.trim()}
                    >
                      Post
                    </Button>
                  </Box>
                </Paper>
              </Card>
            )}
          </Box>
        </Paper>
      )}
    </Box>
  );
}
function ReplyBox({ value, onChange, onReply }) {
  return (
    <Box display="flex" gap={2} mt={2}>
      <TextField
        value={value}
        onChange={onChange}
        placeholder="Write a reply..."
        size="small"
        fullWidth
      />
      <Button
        variant="contained"
        color="primary"
        onClick={onReply}
        disabled={!value.trim()}
      >
        Post
      </Button>
    </Box>
  );
}
